import { toast } from "sonner";
import { Printer } from "lucide-react";
import { download } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const PrintButton = ({ path, params, testid, label = "Stampa PDF" }) => (
  <Button variant="outline" className="bg-white" data-testid={testid}
    onClick={() => { toast.info("Preparazione della stampa…"); download(path, params).catch((e) => toast.error(e.message)); }}>
    <Printer className="mr-2 h-4 w-4" />{label}
  </Button>
);
